// Static HTML site — no React CSS loaded so Tailwind Preflight doesn't
// override the landing page's inline styles.
import React from "react";
import ReactDOM from "react-dom/client";

function App() {
  return null;
}

const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App />);
}
